import React, { useState } from 'react';
import { useDialog } from '../DialogContext'; 

const VINTAGE_BEIGE = "#e5d1a5"; 
const JERUSALEM_GOLD = "#c5a059"; 

const TreasuryModal = ({ player, setPlayer, setShowShop, buyItem }) => {
  const [isAdding, setIsAdding] = useState(false);
  const [newReward, setNewReward] = useState({ name: "", cost: 20, icon: "🎁" });
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const { showAlert, showConfirm } = useDialog();

  // EMOJİLER CİDDİ ORANDA ARTIRILDI
  const availableEmojis = [
    "🎁", "☕", "📖", "🌿", "🎬", "🎮", "🍷", "🎧", 
    "🍕", "✈️", "🛍️", "🎨", "💃", "🕺", "🍿", "💆‍♀️", 
    "🎤", "🍰", "🏕️", "🧘‍♀️", "🚗", "📱", "🏖️", "🍔",
    "🍦", "🎸", "🏀", "⚽", "🧩", "🎲", "👗", "👠",
    "🧸", "📸", "📺", "🚲", "🍵", "🍣", "🍩", "🛀",
    "🛹", "🏕️", "🎢", "🎡", "🎫", "🍜", "🥂", "🎹"
  ];

  const defaultItems = [
    { id: "def1", name: "Fancy Coffee", icon: "☕", cost: 20, isCustom: false },
    { id: "def2", name: "New Book", icon: "📖", cost: 50, isCustom: false },
    { id: "def3", name: "Day Off", icon: "🌿", cost: 100, isCustom: false },
    { id: "def4", name: "Cinema Ticket", icon: "🎬", cost: 40, isCustom: false }
  ];

  const shopItems = [...defaultItems, ...(player.customRewards || [])];

  const handleAddReward = () => {
    if (!newReward.name || !newReward.cost) return;
    const costNum = parseInt(newReward.cost);
    
    if (isNaN(costNum) || costNum < 20) {
      // SADE VE NET BİR MESAJ
      showAlert("Minimum cost is 20 Wealth.", "Invalid Cost");
      return;
    }

    const customItem = { 
      id: Date.now(), name: newReward.name, icon: newReward.icon || "🎁", cost: costNum, isCustom: true 
    };

    setPlayer(prev => ({ ...prev, customRewards: [...(prev.customRewards || []), customItem] }));
    setIsAdding(false);
    setShowEmojiPicker(false);
    setNewReward({ name: "", cost: 20, icon: "🎁" }); 
  };

  const deleteCustomReward = (id, e) => {
    e.stopPropagation(); 
    // SADE VE NET BİR ONAY
    showConfirm("Delete this reward?", () => {
      setPlayer(prev => ({ ...prev, customRewards: prev.customRewards.filter(r => r.id !== id) }));
    }, "Delete Reward");
  };

  const handleConsumeItem = (id, itemName) => {
    // SADE VE NET BİR KULLANIM MESAJI
    showConfirm(`Use "${itemName}"? This will consume it from your inventory.`, () => {
      setPlayer(prev => ({ ...prev, inventory: prev.inventory.filter(item => item.id !== id) }));
    }, "Use Item");
  };

  return (
    <div className="modal-overlay" onClick={() => setShowShop(false)} style={{backgroundColor: 'rgba(5, 3, 2, 0.9)'}}>
      <div 
        className="modal-content" 
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '850px', width: '95%', padding: '40px', borderRadius: '2px', 
          backgroundColor: 'var(--sidebar-bg)', 
          backgroundImage: `url('https://www.transparenttextures.com/patterns/aged-paper.png')`, 
          border: `1px solid ${JERUSALEM_GOLD}`, 
          boxShadow: 'inset 0 0 50px rgba(0,0,0,0.5), 0 15px 50px rgba(0,0,0,0.9)',
          display: 'flex', flexDirection: 'column', maxHeight: '90vh' 
        }} 
      >
        
        {/* HEADER */}
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: `1px solid ${JERUSALEM_GOLD}`, paddingBottom: '15px', marginBottom: '25px'}}>
          <div>
            <h3 style={{fontFamily: 'Cinzel, serif', color: JERUSALEM_GOLD, fontSize: '1.8rem', letterSpacing: '3px', textTransform: 'uppercase', margin: 0, textShadow: '1px 1px 5px rgba(0,0,0,0.8)'}}>
              Treasury
            </h3>
            <p style={{fontFamily: 'Courier Prime, monospace', color: VINTAGE_BEIGE, opacity: 0.8, fontSize: '0.9rem', margin: '5px 0 0 0', letterSpacing: '1px'}}>
              Exchange wealth for rewards.
            </p>
          </div>

          <div style={{display: 'flex', alignItems: 'center', gap: '20px'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '10px', backgroundColor: 'rgba(0,0,0,0.4)', padding: '5px 15px', borderRadius: '2px', border: `1px dashed ${JERUSALEM_GOLD}`}}>
              <span style={{fontFamily: 'Cinzel, serif', fontSize: '0.85rem', color: VINTAGE_BEIGE, letterSpacing: '1px', textTransform: 'uppercase'}}>Wealth:</span>
              <span style={{fontSize: '1.8rem', fontWeight: 'bold', color: JERUSALEM_GOLD, display: 'flex', alignItems: 'center', gap: '5px'}}>
                {player.stats.wealth} <span style={{fontSize: '1.4rem'}}>⚜️</span>
              </span>
            </div>
            <button 
              onClick={() => setShowShop(false)} 
              style={{background: 'none', border: 'none', fontSize: '1.8rem', color: JERUSALEM_GOLD, cursor: 'pointer', transition: 'color 0.2s', padding: 0, lineHeight: 1, textShadow: '1px 1px 2px rgba(0,0,0,0.5)'}}
              onMouseOver={(e) => e.currentTarget.style.color = 'var(--accent-red)'}
              onMouseOut={(e) => e.currentTarget.style.color = JERUSALEM_GOLD}
            >
              ✕
            </button>
          </div>
        </div>

        {/* SHOP ITEMS GRID */}
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: '20px', marginBottom: '20px', overflowY: 'auto', paddingRight: '5px', paddingBottom: '10px'}}>
          
          {shopItems.map((item) => (
            <div key={item.id} style={{
              border: `1px solid ${JERUSALEM_GOLD}`, borderTop: '4px solid var(--accent-red)', padding: '20px 10px', textAlign: 'center', 
              backgroundColor: 'rgba(0,0,0,0.3)', borderRadius: '2px', 
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)', display: 'flex', flexDirection: 'column', alignItems: 'center',
              position: 'relative', boxShadow: '0 4px 10px rgba(0,0,0,0.5)'
            }}
            onMouseOver={(e) => { 
              e.currentTarget.style.transform = 'translateY(-5px)'; 
              e.currentTarget.style.borderColor = 'var(--accent-red)'; 
              e.currentTarget.style.boxShadow = `0 0 20px rgba(197, 160, 89, 0.4)`;
            }}
            onMouseOut={(e) => { 
              e.currentTarget.style.transform = 'translateY(0)'; 
              e.currentTarget.style.borderColor = JERUSALEM_GOLD; 
              e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.5)';
            }}
            >
              {item.isCustom && (
                <button 
                  onClick={(e) => deleteCustomReward(item.id, e)}
                  style={{position: 'absolute', top: '5px', right: '5px', background: 'none', border: 'none', color: VINTAGE_BEIGE, opacity: 0.5, cursor: 'pointer', fontSize: '0.9rem', transition: '0.2s', zIndex: 2}}
                  title="Delete"
                  onMouseOver={(e) => { e.currentTarget.style.color = 'var(--accent-red)'; e.currentTarget.style.opacity = 1; }}
                  onMouseOut={(e) => { e.currentTarget.style.color = VINTAGE_BEIGE; e.currentTarget.style.opacity = 0.5; }}
                >
                  ✕
                </button>
              )}

              <div style={{fontSize: '2.8rem', marginBottom: '15px', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50px', width: '100%', textShadow: '2px 2px 5px rgba(0,0,0,0.5)'}}>
                {item.icon}
              </div>
              <span style={{fontFamily: 'Courier Prime, monospace', fontWeight: 'bold', color: '#fdfbf7', marginBottom: '20px', fontSize: '0.95rem', lineHeight: '1.3', minHeight: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                {item.name}
              </span>
              
              <button
                style={{
                  marginTop: 'auto', width: '100%', 
                  background: player.stats.wealth >= item.cost ? 'var(--accent-red)' : 'rgba(0,0,0,0.5)', 
                  border: player.stats.wealth >= item.cost ? '1px solid #5a0d0e' : `1px dashed ${JERUSALEM_GOLD}`, 
                  color: player.stats.wealth >= item.cost ? JERUSALEM_GOLD : 'rgba(197, 160, 89, 0.4)', 
                  padding: '10px', fontFamily: 'Cinzel, serif', fontWeight: 'bold', 
                  letterSpacing: '1.5px', cursor: player.stats.wealth >= item.cost ? 'pointer' : 'not-allowed', 
                  fontSize: '0.9rem', borderRadius: '2px', height: 'auto', transition: 'all 0.2s',
                  textTransform: 'uppercase', boxShadow: player.stats.wealth >= item.cost ? '0 2px 4px rgba(0,0,0,0.3)' : 'none'
                }}
                onMouseOver={(e) => { 
                  if(player.stats.wealth >= item.cost) { 
                    e.currentTarget.style.backgroundColor = '#5a0d0e'; 
                    e.currentTarget.style.borderColor = JERUSALEM_GOLD;
                    e.currentTarget.style.transform = 'translateY(-1px)';
                  } 
                }}
                onMouseOut={(e) => { 
                  if(player.stats.wealth >= item.cost) { 
                    e.currentTarget.style.backgroundColor = 'var(--accent-red)'; 
                    e.currentTarget.style.borderColor = '#5a0d0e';
                    e.currentTarget.style.transform = 'translateY(0)';
                  } 
                }}
                onClick={() => buyItem(item.name, item.cost)}
                disabled={player.stats.wealth < item.cost}
              >
                BUY • {item.cost}
              </button>
            </div>
          ))}

          {/* ADD ITEM CARD */}
          {isAdding ? (
            <div style={{ border: `1px dashed ${JERUSALEM_GOLD}`, padding: '15px 10px', textAlign: 'center', backgroundColor: 'rgba(0,0,0,0.4)', borderRadius: '2px', display: 'flex', flexDirection: 'column', position: 'relative' }}>
              
              <div style={{position: 'relative', marginBottom: '15px'}}>
                <button 
                  onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                  style={{
                    fontSize: '2rem', background: 'rgba(0,0,0,0.5)', border: `1px solid ${JERUSALEM_GOLD}`, 
                    color: '#fff', borderRadius: '2px', cursor: 'pointer', padding: '0', width: '100%', 
                    transition: 'background 0.2s', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50px'
                  }}
                  title="Choose Icon"
                >
                  {newReward.icon}
                </button>
                
                {showEmojiPicker && (
                  <div style={{
                    position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)', zIndex: 100, 
                    backgroundColor: 'var(--sidebar-bg)', border: `1px solid ${JERUSALEM_GOLD}`, padding: '10px', display: 'flex', 
                    flexWrap: 'wrap', gap: '8px', width: '220px', justifyContent: 'center', boxShadow: '0 5px 20px rgba(0,0,0,0.9)', borderRadius: '2px', marginTop: '5px'
                  }}>
                    {availableEmojis.map(emoji => (
                      <span key={emoji} style={{fontSize: '1.4rem', cursor: 'pointer', padding: '4px', transition: 'transform 0.2s'}} 
                            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.2)'}
                            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            onClick={() => { setNewReward({...newReward, icon: emoji}); setShowEmojiPicker(false); }}>
                        {emoji}
                      </span>
                    ))}
                  </div>
                )}
              </div>

              <input 
                style={{width: '100%', marginBottom: '10px', textAlign: 'center', padding: '10px', fontSize: '0.9rem', backgroundColor: 'rgba(0,0,0,0.5)', border: 'none', borderBottom: `1px solid ${JERUSALEM_GOLD}`, color: '#fdfbf7', outline: 'none', borderRadius: '0', fontFamily: 'Courier Prime'}} 
                className="vintage-input"
                placeholder="Item Name" value={newReward.name} onChange={(e) => setNewReward({...newReward, name: e.target.value})}
              />
              <input 
                type="number" min="20" style={{width: '100%', marginBottom: '20px', textAlign: 'center', padding: '10px', fontSize: '0.9rem', backgroundColor: 'rgba(0,0,0,0.5)', border: 'none', borderBottom: `1px solid ${JERUSALEM_GOLD}`, color: '#fdfbf7', outline: 'none', borderRadius: '0', fontFamily: 'Courier Prime'}} 
                className="vintage-input"
                placeholder="Cost (Min 20)" value={newReward.cost} onChange={(e) => setNewReward({...newReward, cost: e.target.value})}
              />
              <div style={{display: 'flex', gap: '8px', marginTop: 'auto'}}>
                <button 
                  style={{flex: 1, padding: '8px', fontSize: '0.85rem', fontFamily: 'Cinzel, serif', fontWeight: 'bold', backgroundColor: 'var(--accent-red)', color: JERUSALEM_GOLD, border: '1px solid #5a0d0e', cursor: 'pointer', borderRadius: '2px', transition: '0.2s'}} 
                  onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#5a0d0e'; e.currentTarget.style.borderColor = JERUSALEM_GOLD; }}
                  onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'var(--accent-red)'; e.currentTarget.style.borderColor = '#5a0d0e'; }}
                  onClick={handleAddReward}>ADD</button>
                <button 
                  style={{flex: 1, padding: '8px', fontSize: '0.85rem', fontFamily: 'Cinzel, serif', fontWeight: 'bold', backgroundColor: 'transparent', color: VINTAGE_BEIGE, border: `1px solid ${JERUSALEM_GOLD}`, cursor: 'pointer', borderRadius: '2px', transition: '0.2s'}} 
                  onMouseOver={(e) => { e.currentTarget.style.backgroundColor = 'rgba(197, 160, 89, 0.1)'; }}
                  onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                  onClick={() => {setIsAdding(false); setShowEmojiPicker(false);}}>CANCEL</button>
              </div>
            </div>
          ) : (
            <div 
              onClick={() => setIsAdding(true)}
              style={{ border: `1px dashed ${JERUSALEM_GOLD}`, padding: '20px 10px', textAlign: 'center', backgroundColor: 'rgba(0,0,0,0.2)', borderRadius: '2px', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', opacity: 0.6, transition: 'all 0.3s' }}
              onMouseOver={(e) => { e.currentTarget.style.opacity = '1'; e.currentTarget.style.borderColor = 'var(--accent-red)'; e.currentTarget.style.backgroundColor = 'rgba(139, 58, 58, 0.1)'; e.currentTarget.style.boxShadow = `0 0 15px rgba(139, 58, 58, 0.3)`; }}
              onMouseOut={(e) => { e.currentTarget.style.opacity = '0.6'; e.currentTarget.style.borderColor = JERUSALEM_GOLD; e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.2)'; e.currentTarget.style.boxShadow = 'none'; }}
            >
              <div style={{fontSize: '2.5rem', color: JERUSALEM_GOLD, marginBottom: '10px'}}>+</div>
              <span style={{fontFamily: 'Cinzel, serif', fontWeight: 'bold', color: JERUSALEM_GOLD, fontSize: '1rem', letterSpacing: '1px', textTransform: 'uppercase'}}>Create</span>
            </div>
          )}

        </div>

        {/* INVENTORY */}
        <div style={{borderTop: `1px dashed ${VINTAGE_BEIGE}`, paddingTop: '20px', marginTop: 'auto'}}>
          <h4 style={{fontFamily: 'Cinzel, serif', color: JERUSALEM_GOLD, fontSize: '1.2rem', marginBottom: '15px', letterSpacing: '2px', textTransform: 'uppercase', textShadow: '1px 1px 2px rgba(0,0,0,0.5)'}}>
            Inventory
          </h4>
          
          <div style={{display: 'flex', flexWrap: 'wrap', gap: '12px', maxHeight: '18vh', overflowY: 'auto', paddingRight: '5px'}}>
            {player.inventory?.length > 0 ? (
              player.inventory.slice().reverse().map(i => {
                
                // HARİKA DOKUNUŞ: İsimden ShopItem'ı bulup EMOJİSİNİ çekiyoruz! 
                // Bulamazsa varsayılan olarak bilet (🎫) kullanacak.
                const matchedShopItem = shopItems.find(item => item.name === i.text);
                const displayIcon = matchedShopItem ? matchedShopItem.icon : "🎫";

                return (
                  <div key={i.id} style={{
                    backgroundColor: 'rgba(0,0,0,0.6)', color: '#fdfbf7', padding: '6px 6px 6px 12px', 
                    border: `1px solid ${JERUSALEM_GOLD}`, borderRadius: '25px', 
                    fontFamily: 'Courier Prime, monospace', fontSize: '0.95rem', 
                    display: 'flex', alignItems: 'center', gap: '15px',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.5)'
                  }}>
                    <span style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                      <span style={{fontSize: '1.2rem'}}>{displayIcon}</span> 
                      <span>{i.text}</span>
                    </span>
                    
                    <button 
                      onClick={() => handleConsumeItem(i.id, i.text)}
                      style={{
                        backgroundColor: 'var(--accent-red)', color: JERUSALEM_GOLD, border: 'none',
                        padding: '6px 12px', fontSize: '0.8rem', fontFamily: 'Cinzel, serif', cursor: 'pointer',
                        borderRadius: '20px', fontWeight: 'bold', transition: '0.2s', letterSpacing: '1px'
                      }}
                      onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#5a0d0e'; }}
                      onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'var(--accent-red)'; }}
                    >
                      USE
                    </button>
                  </div>
                )
              })
            ) : (
              <span style={{opacity: 0.6, fontStyle: 'italic', fontFamily: 'Courier Prime, monospace', fontSize: '0.95rem', color: VINTAGE_BEIGE}}>
                Your inventory is empty.
              </span>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default TreasuryModal;